module.exports = __webpack_public_path__ + "images/help_v2/avatars/biallo-34bf680eeaf3eb6ef1b61c6eb6e4b081.png";